/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { SubmitRelayTransactionResponse, SubmitRelayTransactionVars } from '../openapi-types.gen.js';

export type { SubmitRelayTransactionResponse, SubmitRelayTransactionVars } from '../openapi-types.gen.js';

export const useSubmitRelayTransaction = createMutationHook<SubmitRelayTransactionVars, SubmitRelayTransactionResponse, unknown>({
  specName: 'useSubmitRelayTransaction',
  path: '/v1/transactions/submit',
  method: 'POST',
  resolveUrl: (vars: SubmitRelayTransactionVars) => `/v1/transactions/submit`,
  buildBody: (vars: SubmitRelayTransactionVars) => ({ signedTransaction: vars.signedTransaction, walletAddress: vars.walletAddress }),
  parseResponse: (raw: unknown): SubmitRelayTransactionResponse => raw as SubmitRelayTransactionResponse,
  
  
  
});
